<template>
  <div>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="onSubmit">批量导入</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <h3 v-if="query" style="margin-bottom:16px;">{{$store.state.themeTitle}}室：{{query.training_name}}</h3>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" min-width="150">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="160" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="order_user_name" label="预约人" width="100">
        </custom-table-column>
        <custom-table-column prop="order_user_dep" label="预约人院系" width="160">
        </custom-table-column>
        <custom-table-column prop="phone" label="预约人手机号" width="100">
        </custom-table-column>
        <custom-table-column prop="order_start" label="开始时间" width="150">
        </custom-table-column>
        <custom-table-column prop="order_end" label="结束时间" width="150">
        </custom-table-column>
        <custom-table-column prop="instrument_name" label="设备名称" width="120">
        </custom-table-column>
        <!-- <custom-table-column prop="email" label="采购人邮箱" width="150">
        </custom-table-column> -->
        <!-- <custom-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row)" type="text" size="small">删除</el-button>

          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="`${$store.state.themeTitle}室设备`":visible.sync="centerDialogVisible" width="500">
      <span>{{$store.state.themeTitle}}室设备信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageLine from '@/components/page.vue';
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'notice',
  props: ['query'],
  mixins: [mixinList,mixinFormatter],
  data() {
    return {
      formInline: {
        training_room_id: '',
        device_name: '',
        // date: '',
      },
      centerDialogVisible: false,
      total: 0,
      tableData: [],
    };
  },
  components: {
    PageLine,
  },
  created() {
    // console.log(this.query, 111);
    if (this.query) {
      this.formInline.training_room_id = this.query.training_id;
    }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      params.training_room_id = this.formInline.training_room_id
      params.device_name = this.formInline.device_name
      let res = await this.$api.query.getEqYY(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleDelet() {
      this.$message.info('删除中。。。');
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
